import {
  DueOutFetchArgs,
  DueOutStatusCount,
  getDueoutStatusCounts,
} from '../../assets/ts/data/dueout/dueout'
import useServerData from '../use-server-data'

function useDueOutStatusCounts(fetchArgs: DueOutFetchArgs) {
  const {
    data: dueOutStatusCounts,
    error: dueOutStatusCountsError,
    fetchData: fetchDueOutStatusCounts,
    isLoading: dueOutStatusCountsIsLoading,
  } = useServerData<DueOutStatusCount, DueOutFetchArgs>(
    getDueoutStatusCounts,
    fetchArgs
  )

  return {
    dueOutStatusCounts,
    dueOutStatusCountsError,
    dueOutStatusCountsIsLoading,
    fetchDueOutStatusCounts,
  }
}

export default useDueOutStatusCounts
